import React from 'react'
import { hooks } from '@front/volcanion'

import { Box } from '@mui/material'

import OptionDetails from '@abra/frames/Option'

const VehicleOptionPage = props => {
  const { vehicle_option_id } = hooks.useParams()
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: 2 / 3 }}>
        <OptionDetails record_id={vehicle_option_id} model_name='vehicleoption' />
      </Box>
    </Box>
  )
}

export default React.memo(VehicleOptionPage)
